import { communicationsApi } from '@app/services'
import { isBuyerView } from '@app/utils'

export const readChat = async (
  identity: string,
  token: string,
  convId?: number | string
) => {
  if (isBuyerView()) {
    return null
  }

  const { data } = await communicationsApi.post(`/chat/${convId}/read`, null, {
    headers: {
      'X-ACS-ParticipantId': identity,
      'X-ACS-Token': token,
    },
  })

  return data
}
